import { render, staticRenderFns } from "./liveStudentList.vue?vue&type=template&id=567a034a&scoped=true"
import script from "./liveStudentList.vue?vue&type=script&lang=js"
export * from "./liveStudentList.vue?vue&type=script&lang=js"
import style0 from "./liveStudentList.vue?vue&type=style&index=0&id=567a034a&prod&lang=less"
import style1 from "./liveStudentList.vue?vue&type=style&index=1&id=567a034a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a034a",
  null
  
)

export default component.exports